module.exports = __webpack_public_path__ + "static/media/31_B.ce957b74.png";